export const AMPLIFY_DESMOS_MATH_ASSET = '2852f8f4-3d3b-414b-affa-17b801e6c60a';
export const MCLASS_ASSET = '6a82c1ff-4da0-4560-b652-c470c19cecec';
export const PD_LIBRARY_ASSET = '16903210-71e4-4237-9da1-9e6a11bea8c8';
export const TX_ASSET_BK = '1fcad967-4656-4b63-98c6-566a44e19e9b';
export const BOOST_EM_ASSET = '9c92c30e-06da-4ab8-8c60-0c7c2a63409d';
